import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  tagsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  clampedText: {
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  readMoreContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
  },
  readMoreButton: {
    padding: 0,
    textTransform: 'none',
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
    '&:hover': {
      background: 'transparent',
      textDecoration: 'underline',
    },
  },
  mandatoryChip: {
    marginLeft: theme.spacing(1),
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    verticalAlign: 'middle',
  },
}));
